import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    text-align: center;
    padding-top: 6em;
    background-color: #F3F3F3;

    .title-section {
        font-weight: 600;
        font-size: 2.4em;
        margin-bottom: 3em;
    }

    .section-container {
        margin-bottom: 6em;
        position: relative;
        z-index: 2;

        &:last-of-type {
            padding-top: 6em;
            padding-bottom: 6em;
            margin-bottom: 0;
        }

        .cols {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            position: relative;
            z-index: 1;

            .left {
                text-align: left;
                padding-right: 1em;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
            }
            .left-list {
                .description {
                    text-align: left;
                }
            }
            .right {
                text-align: right;
                padding-left: 1em;
            }

            .image-left {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
            }

            .image-right {
                display: flex;
                align-items: flex-start;
                justify-content: flex-end;
            }

            .col-text {
                width: 50%;

                .title {
                    font-weight: 600;
                    font-size: 1.8em;
                    margin-bottom: 2.2em;
                }

                .description {
                    font-size: 1.05em;
                    margin-bottom: 1.2em;
                }

                .image-description {
                    margin-left: 2em;
                    position: relative;

                    img {
                        position: absolute;
                        top: 50%;
                        left: -2em;
                        transform: translate(0, -50%);
                    }
                }

                .layout-button {
                    margin: 1.2em 0 0;
                }

                .button-wrapper {
                    display: flex;
                    align-items: flex-end;
                    justify-content: flex-end;
                    width: 100%;

                    .control{
                        margin-right: 1.8em;
                        width: 100%;

                        .button-title{
                            margin-bottom: -.5em;
                            margin-top: .5em;
                            font-size: 1.025em;
                        }

                        .layout-button {
                            &:last-of-type{
                                margin-left: 0;
                            }
                        }
                    }

                    .layout-button {
                        &:last-of-type{
                            margin-left: 1.4em;
                        }
                    }
                }
            }

            .col-image {
                width: 50%;

                img {
                    width: 33em;
                    height: 26em;
                    object-fit: cover;
                }
            }

            .about-slick{
                max-width: 100%;
                margin: 0 auto;
                display: none;
                position: relative;

                .img-top {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 11;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletL}) {
        .section-container {
            .cols {
                .left {
                    padding-right: 2em;
                }

                .right {
                    padding-left: 2em;
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletS}) {
        padding-top: 2em;

        .title-section {
            margin-bottom: 2em;
        }
        .section-container {
            margin-bottom: 2em;

            .cols {
                flex-direction: column-reverse;
                padding-left: 1em;
                padding-right: 1em;

                .left {
                    text-align: center;
                    padding-right: 0;
                }

                .right {
                    text-align: center;
                    padding-left: 0;
                }

                .col-text {
                    width: 100%;
                    margin-bottom: 1em;
                    .title {
                        width: 100%;
                    }
                    .layout-button {
                        width: 100%;

                        a {
                            width: 100%;

                            button {
                                width: 100%;
                            }
                        }
                    }

                    .button-wrapper {
                        .control{
                            margin-right: 0;
                            margin-bottom: 1.2em;
                        }
                        .layout-button {
                            &:last-of-type{
                                margin-left: 0;
                            }
                        }
                    }

                    .button-wrapper {
                        flex-direction: column;
                        width: 100%;

                        .layout-button {
                            width: 100%;
                            margin-left: 0;

                            a {
                                width: 100%;

                                button {
                                    width: 100%;
                                }
                            }
                        }
                    }

                    .title {
                        margin-bottom: 1.2em;
                    }

                    .image-description {
                        text-align: left;
                    }
                }

                .col-image {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 3em;
                }

                .mobile-image {
                    display: none;
                }

                .about-slick{
                    display: block;
                }
            }

            .reverse {
                flex-direction: column;
                margin-bottom: -5em;
            }
        }
    }
`;